<div class="process-details-container">
  <app-technician-data *ngIf="loadGridConnectionComponents" [isReadOnly]="true" [isDetailsView]="isDetailsView"></app-technician-data>
  <app-technical-data *ngIf="installationType === 'feedin'" [isReadOnly]="dataIsEditable ? isReadOnly : true"></app-technical-data>
  <app-siteelectricity-installation-technical-data
    *ngIf="installationType === 'construction_site_installation'"
    [isReadOnly]="dataIsEditable ? isReadOnly : true"></app-siteelectricity-installation-technical-data>

  <div class="installation-forms-section" [class.column-reverse]="showTechnicalFormFirst">
    <div>
      <app-personal-data
        *ngIf="loadInstallationApplicationComponents || loadGridConnectionComponents"
        [isReadOnly]="dataIsEditable ? isReadOnly : true"></app-personal-data>
      <h1>
        <div class="page-break">Page break</div>
      </h1>
    </div>

    <div *ngFor="let facility of facilityTypes; let index = index">
      <app-facilities-data
        *ngIf="
          loadInstallationApplicationComponents && installationType !== 'construction_site_installation' && installationType !== 'feedin'
        "
        [isReadOnly]="dataIsEditable ? isReadOnly : true"
        [currentFormType]="facility"></app-facilities-data>
      <h1 *ngIf="loadInstallationApplicationComponents">
        <div class="page-break">Page break</div>
      </h1>
    </div>
    <div class="ui-g-12 submit-button-section text-center bottom-padding" *ngIf="dataIsEditable">
      <button
        pButton
        label="{{ 'change-password.submit-button-label' | translate | uppercase }}"
        class="submit-button"
        (click)="updateApplicationData()"></button>
    </div>
  </div>

  <app-order-process-documents
    *ngIf="loadInstallationApplicationComponents || loadGridConnectionComponents"
    [isReadOnly]="isReadOnly"></app-order-process-documents>

  <app-order-process
    *ngIf="loadInstallationApplicationComponents || loadGridConnectionComponents"
    [isInstallationFlow]="loadInstallationApplicationComponents"
    [isConnectionFlow]="loadGridConnectionComponents"
    (executorActionEvent)="setExecutorAction($event)"
    [isReadOnly]="isReadOnly"></app-order-process>

  <app-order-history
    *ngIf="loadInstallationApplicationComponents || loadGridConnectionComponents"
    [applicationId]="applicationId"></app-order-history>

  <div class="text-right-align top-margin send-message-section" *ngIf="showSendMessageButton">
    <button class="action-button" label="{{ 'send-message-button-label' | translate }}" pButton (click)="sendMessage()"></button>
  </div>
  <div
    class="text-right-align top-margin send-message-section"
    *ngIf="loadInstallationApplicationComponents || loadGridConnectionComponents">
    <button class="action-button" label="Download" pButton (click)="downloadAllDocuments()"></button>
    <button class="action-button" label="Print" pButton (click)="print()"></button>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
